import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('marketName', {
        template: require('./marketNameComponent.html'),
        controller: ['$scope', '$uibModal', angularServicesNames.$translate, 'marketDefinitionService', AgGridService.componentName, 'AlertService',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $uibModal: ng.ui.bootstrap.IModalService,
                $translate: ng.translate.ITranslateService,
                marketDefinitionService: $TSFixMe,
                agGridService: AgGridService,
                AlertService: AlertService
            ) {
                var $ctrl = this;
                $scope.model = {};
                $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.actions = {};

                $ctrl.gridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("CONFIGURATION.MARKET_NAME.NAME"),
                            field: "name"
                        },
                        {
                            headerValueGetter: () => $translate.instant("ACTIONS"),
                            cellRenderer: () =>
                            `<div  class="ui-grid-cell-contents">
                                <a href="#" ng-click="$ctrl.actions.edit(data)"><i class="glyphicon glyphicon-edit"></i></a>
                                <a href="#" ng-click="$ctrl.actions.remove(data)"><i class="glyphicon deactivate-icon glyphicon-remove-circle"></i></a>
                            </div>`,
                        sortable: false,
                        suppressMenu: true
                        }
                    ],
                    domLayout: 'autoHeight',
                    angularCompileRows: true,
                    defaultColDef: { 
                        sortable: true,
                        resizable: true
                    },
                    enableFilter: false,
                    animateRows: true,
                    pagination: true,
                    paginationPageSize: 15,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        loadData();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                };

                $ctrl.actions = {
                    edit: function (entity: $TSFixMe) {
                        var modalInstance = $uibModal.open({
                            component: 'marketNameEdit',
                            resolve: {

                                model: () => angular.copy(entity),
                                options: () => "edit"
                            }
                        });
                        modalInstance.result.then((response: $TSFixMe) => {
                            marketDefinitionService.edit(response).
                                then((response: $TSFixMe) => {
                                    if (response.status == HttpStatus.OK || response.status == 204) {
                                        loadData();
                                    } else {
                                        errorHandler(response)
                                    }
                                }, () => { });
                        });
                    },
                    add: function () {
                        var modalInstance = $uibModal.open({
                            component: 'marketNameEdit',
                            resolve: {
                                model: () => { },
                                options: () => "add"
                            }
                        });
                        modalInstance.result.then((response: $TSFixMe) => {
                            marketDefinitionService.edit(response).
                                then((response: $TSFixMe) => {
                                    if (response.status == HttpStatus.OK || response.status == 204) {
                                        loadData();
                                    } else {
                                        errorHandler(response)
                                    }
                                }, () => { });
                        });
                    },
                    remove: function (entity: $TSFixMe) {
                        marketDefinitionService.remove(entity)
                            .then(() => loadData());
                    }
                }

                function loadData() {
                    marketDefinitionService.get().then((items: $TSFixMe) => {
                        $ctrl.gridApi.setRowData(items);
                    });
                }

                const errorHandler = (err: $TSFixMe) => {
                    switch (err.status) {
                        case HttpStatus.Conflict:
                            AlertService.error($translate.instant('CONFIGURATION.MARKET_NAME.NAME_NOT_UNIQUE'));
                            break;
                    }
                }
            }]
    });

}(angular.module('topline.modules')));